// extracted by mini-css-extract-plugin
export default {"detailsReviews":"DetailReviews_detailsReviews__Kxiud","detailsReviewsContainer":"DetailReviews_detailsReviewsContainer__bXpeQ","button":"DetailReviews_button__4IXNV"};